export enum ERoutePath {
  HOME = '/',
  SOFTWARE_DEVELOPMENT_SERVICE = '/software-development-service',
  INNOVATIVE_TECHNOLOGY_SOLUTION = '/innovative-technology-solution',
  ENTERPRISE_SOLUTIONS_CLOUD_IT_SERVICES = '/enterprise-solutions-cloud-it-services',
  TRADING_SYSTEM_SOLUTIONS = '/trading-system-solutions',
  CLIENT_APPLICATION_AREAS = '/client-application-areas',
  CORE_SERVICES = '/core-services',
  COMPANY_INFORMATION = '/company-information',
}
